import { setSearchTerm } from '../State/searchTerms';

export default (query) => async (dispatch) => {

  dispatch(setSearchTerm(query.target.value));
    
}